import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ToastContainerComponent } from './toast/toast-container.component';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SegmentedControlComponent } from './components/segmented-control/segmented-control.component';

/**
 * Shared UI — import in every feature module that needs shared components.
 * Must export every component/pipe/directive it declares.
 */
@NgModule({
  declarations: [
    ConfirmDialogComponent,
    ToastContainerComponent,
    CustomDropdownComponent,
    LoaderComponent,
    SegmentedControlComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    // Angular modules re-exported for feature convenience
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    // KinSphere shared components
    ConfirmDialogComponent,
    ToastContainerComponent,
    CustomDropdownComponent,
    LoaderComponent,
    SegmentedControlComponent,
  ],
})
export class SharedModule {}
